/* jshint eqnull:true */

/**
 * This module is responsible for the flyGarmin-specific aspects of client-side form validation. It builds on
 * jquery.html5forms, which doesn't have any flyGarmin-specific details. Primarily, it deals with displaying validation
 * errors using flyGarmin's classes.
 */
define(['jquery', 'jquery.html5forms'],
function($) {

	"use strict";

	var FIELD_ERROR_ELEMENT_KEY = "field-error-element";
	var FLY_OVERRIDE_NOVALIDATE_KEY = "fly-forms-override-validate";

	// This is a back door to disable client-side form validation. You can activate it by setting a cookie:
	// "DisableClientValidation=true". It is useful to test that server-side validation is working properly. It isn't a
	// security issue since there is nothing stopping the user from disabling validation in other ways.
	//
	// Note that due to the way this script interacts with the browser's native validation support, you may have to
	// hit the submit button twice.
	var disableValidation = /(^|;)\s*DisableClientValidation\s*=\s*true\s*($|;)/.test(document.cookie);


	function isValidationDisabled($formOrField) {
		// Global flag to disable validation
		if (disableValidation)
			return true;

		if ($formOrField.is("form")) {
			// If "novalidate" is set on the form and it wasn't set by us, then don't validate
			if ($formOrField.attr("novalidate") != null && !$formOrField.data(FLY_OVERRIDE_NOVALIDATE_KEY))
				return true;
		}
		else {
			var field = $formOrField[0];
			var form = field && "form" in field && field.form;
			if (form)
				return isValidationDisabled($(form));
		}

		return false;
	}


	function fieldGroup($field) {
		if (!$field.is('input[type="radio"]'))
			return $field;

		var form = $field.prop('form');
		var name = $field.prop('name').toLowerCase();
		return $('input[type="radio"]').filter(function() {
			return form === this.form &&
			       name === this.name.toLowerCase();
		});
	}


	function getFieldErrorElement($field) {
		var $errorElem = $field.data(FIELD_ERROR_ELEMENT_KEY);
		if ($errorElem == null) {
			var $fieldGroup = fieldGroup($field);

			// Try to find an error element that is associated with the field via a data-for attribute
			$fieldGroup.each(function() {
				var fieldID = this.id;
				if (fieldID != null) {
					var $errorElemWithForAttr = $('.field-errors[data-for="' + fieldID + '"]');
					if ($errorElemWithForAttr.length !== 0) {
						$errorElem = $errorElemWithForAttr;
						return false;
					}
				}
			});

			// Otherwise, create a new element
			if ($errorElem == null) {
				// Find an intelligent place to insert the element. It shouldn't go between an element and its label.

				var $insertionPoint = $field;

				var fieldID = $field.prop('id');
				var $parentLabel = $field.parents('label');
				if ($parentLabel.length !== 0) {
					$insertionPoint = $parentLabel;
				}
				else if (fieldID != null) {
					var $siblingLabel = $field.next('label').filter(function() { return this.htmlFor == fieldID; });
					if ($siblingLabel.length !== 0)
						$insertionPoint = $siblingLabel;
				}


				// Insert the element *after* a space, since it is inline

				var $space = $(document.createTextNode(' ')).insertAfter($insertionPoint.first());
				$errorElem = $('<span class="field-errors"></span>').insertAfter($space);
			}

			$fieldGroup.data(FIELD_ERROR_ELEMENT_KEY, $errorElem);
		}
		return $errorElem;
	}

	function updateValidity($fieldGroup) {
		var $field = $fieldGroup.first();
		var message = $field.validationMessage();
		getFieldErrorElement($field).text(message);
		if (message === '')
			$fieldGroup.removeClass('invalid').addClass('valid');
		else
			$fieldGroup.removeClass('valid').addClass('invalid');

		// Custom event for any other modules waiting for validation
		$field.trigger('field-validated');
	}

	function markInteracted($fieldGroup) {
		$fieldGroup.addClass('interacted');
	}


	// Validate forms on attempted submission
	$(document).on('submit', 'form', function(e) {
		var $form = $(e.target);

		if (isValidationDisabled($form))
			return;

		var valid = $form.reportValidity();
		if (!valid) {
			e.preventDefault();
			e.stopPropagation();
		}
		else {
			// Because this submit event handler is registered on the document, it will be run after any
			// "submit" event handlers registered on the form itself. This makes it difficult add a form-
			// specific submit handler that is only run after the validity check. Use a custom event to
			// provide this hook.
			var validEvent = $.Event("fly:submit-valid");
			$form.triggerHandler(validEvent);

			// Let the "fly:submit-valid" handler prevent form submission
			if (validEvent.isDefaultPrevented())
				e.preventDefault();
		}
	});

	// Disable the browser's default validation messages. We have to do this with addEventListener because the native
	// event only captures (not bubbles), and jQuery only registers handlers in the bubbling phase. We shouldn't have to
	// worry about browsers that don't support addEventListener (old IE), because they don't natively support form
	// validation either.
	if ('addEventListener' in document) {
		document.addEventListener('invalid', function(e) {
			e.preventDefault();
			e.stopPropagation();

			var target = e.target;

			// Turn off native validation on this form and let us handle it from now on
			if ('form' in target && !target.form.noValidate) {
				target.form.noValidate = true;
				$(target.form).data(FLY_OVERRIDE_NOVALIDATE_KEY, true);
				$(target.form).reportValidity();
			}
		}, true);
	}

	var validatableElements = ["input", "select", "textarea"];
	$(document).on('change invalid', validatableElements.join(','), function(e) {
		if (isValidationDisabled($(e.target)))
			return;
		var $fieldGroup = fieldGroup($(e.target));
		markInteracted($fieldGroup);
		updateValidity($fieldGroup);
	});

	// The click event is more appropriate than change for inputs and radios
	$(document).on('click', 'input[type="checkbox"], input[type="radio"]', function(e) {
		if (isValidationDisabled($(e.target)))
			return;
		var $fieldGroup = fieldGroup($(e.target));
		markInteracted($fieldGroup);
		updateValidity($fieldGroup);
	});

	// It is best to avoid displaying validation messages until the user has finished typing in the field, so we only
	// validate on the keyup event if the "interacted" class has been added to the element.
	var interactedValidatableElements = $.map(validatableElements, function(elem) { return elem + '.interacted'; });
	$(document).on('keyup', interactedValidatableElements.join(','), function(e) {
		if (isValidationDisabled($(e.target)))
			return;
		var $fieldGroup = fieldGroup($(e.target));
		updateValidity($fieldGroup);
	});

});
